/*
 * @Author: Wang Wenmao
 * @Date: 2023-11-30 16:42:44
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2023-12-06 16:05:30
 * @Description: ...
 */
import React, { PureComponent } from 'react';
import { Row, Col } from 'antd';
import { UploadPicture } from '../../tools';
import './upload-img.less';

const getImageSize = (imageUrl: string, callback: Function) => {
    const img = new Image();
    img.onload = function() {
        const width = img.width;
        const height = img.height;
        callback(null, width, height);
    };
    img.onerror = function() {
        callback('Failed to load image', null, null);
    };
    img.src = imageUrl;
};

//图片广告位项
interface IProps {
    sourceRoot?: {
        image?: string;
    };
    tip: string;
    value: string;
    uploadAction?: string;
    onChangeItem: (e: any) => void;
}

export class UploadImg extends PureComponent<IProps> {
    handleChangeItem = (path) => {
        const { onChangeItem } = this.props;
        if (Array.isArray(path)) {
            onChangeItem('');
        } else {
            getImageSize(path, (err: any, width: any, height: any) => {
                if (!err) {
                    onChangeItem(`${path}?width=${width}&height=${height}`);
                }
            });
        }
    };
    render() {
        const { value, uploadAction, sourceRoot, tip } = this.props;

        return (
            <Row className="entry-item upload-img-wrap">
                <Col className="entry-item-image" span={6}>
                    <UploadPicture
                        sourceRoot={sourceRoot}
                        value={value}
                        uploadAction={uploadAction}
                        onChange={(path) => this.handleChangeItem(path)}
                    />
                </Col>
                <Col className="entry-item-content" span={17}>
                    <div>{tip}</div>
                </Col>
            </Row>
        );
    }
}
